var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_161",
    "data-name": "Gruppe 161",
    xmlns: "http://www.w3.org/2000/svg",
    width: 174.443,
    height: 50,
    viewBox: "0 0 174.443 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1",
    "data-name": "Pfad 1",
    d: "M-470.129,135.057c-13.065,0-22.548,10.344-22.548,24.6s9.483,24.6,22.548,24.6,22.547-10.345,22.547-24.6-9.483-24.6-22.547-24.6m0,49.6c-13.292,0-22.939-10.514-22.939-25s9.648-25,22.939-25,22.938,10.514,22.938,25-9.647,25-22.938,25",
    transform: "translate(621.634 -134.654)",
    fill: "#161d1b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2",
    "data-name": "Pfad 2",
    d: "M-732.156,140.694l-17.108,47.118h-.367l-16-46.448-16,46.448H-782L-799.1,140.694h.417l16.867,46.459,16-46.459h.369l16,46.459,16.868-46.459Z",
    transform: "translate(851.934 -139.252)",
    fill: "#161d1b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3",
    "data-name": "Pfad 3",
    d: "M-987.569,135.058c13.89,0,21.635,10.186,21.708,24.4h-43.35c.082-14.209,8.749-24.4,21.642-24.4m20.4,36.15c-2.915,7.747-10.891,13.044-19.942,13.044-12.912,0-22.013-10.186-22.1-24.4h43.742v-.2c0-14.583-7.98-25-22.1-25-13.067,0-21.952,10.321-22.034,24.8h0v.4h0c.086,14.352,9.281,24.8,22.49,24.8,9.234,0,17.443-5.462,20.383-13.447Z",
    transform: "translate(1009.604 -134.655)",
    fill: "#161d1b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0f1f2c1ae8ab192009eba86995bc94d7.svg";
export { ForwardRef as ReactComponent };